import { Component } from "react";
import { RefreshCw, AlertTriangle } from "lucide-react";

/**
 * Global Error Boundary — mencegah "layar putih".
 * Jika ada komponen yang crash saat render, tampilkan pesan ramah + tombol
 * reload, bukan halaman kosong. Melindungi semua aksi Save/Submit/Record.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" style={{
          minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center",
          padding: 24,
        }}>
          <div style={{
            maxWidth: 520, textAlign: "center", padding: 28, borderRadius: 16,
            background: "var(--surface, #fff)", border: "1px solid var(--border-2, #e2e8f0)",
            boxShadow: "0 10px 40px rgba(11,37,69,.12)",
          }}>
            <div style={{
              width: 56, height: 56, borderRadius: "50%", margin: "0 auto 14px",
              background: "rgba(231,76,60,.12)", display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <AlertTriangle size={26} color="#E74C3C" />
            </div>
            <h2 style={{ margin: "0 0 8px", fontSize: 18, color: "var(--navy, #0B2545)" }}>
              Terjadi kesalahan tak terduga
            </h2>
            <p style={{ margin: "0 0 18px", color: "var(--muted, #6B7A90)", fontSize: 13, lineHeight: 1.6 }}>
              Data Anda aman dan sudah tersimpan. Silakan coba lagi — bagian ini akan dimuat ulang
              tanpa perlu login kembali.
            </p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
              <button className="btn btn-primary" onClick={this.handleReset} data-testid="eb-retry">
                <RefreshCw size={14} /> Coba Lagi
              </button>
              <button className="btn btn-ghost" onClick={() => window.location.reload()} data-testid="eb-reload">
                Muat Ulang Halaman
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
